import type { CreateOrganizationInput, UpdateOrganizationInput } from "../domain/organization";
import type { PaginationOptions } from "../domain/pagination";
import {
  createOrganizationAPI,
  deleteOrganizationAPI,
  fetchOneOrganizationAPI,
  fetchOrganizationsAPI,
  updateOrganizationAPI,
} from "../infrastructure/organization.api";
import type { Organization } from "../infrastructure/organization.formatter";

export function fetchOrganizations(options: PaginationOptions): Promise<Organization[]> {
  return fetchOrganizationsAPI(options);
}

export function fetchOneOrganization(id: string): Promise<Organization> {
  return fetchOneOrganizationAPI(id);
}

export function createOrganization(input: CreateOrganizationInput): Promise<void> {
  return createOrganizationAPI(input);
}

export function updateOrganization(id: string, input: UpdateOrganizationInput): Promise<void> {
  return updateOrganizationAPI(id, input);
}

export function deleteOrganization(id: string): Promise<void> {
  return deleteOrganizationAPI(id);
}
